var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPawIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2969_13416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3489 12.0289C21.427 12.0635 22.3289 11.2175 22.3634 10.1395C22.3979 9.06144 21.552 8.15953 20.4739 8.12501C19.3959 8.09049 18.494 8.93642 18.4595 10.0145C18.4249 11.0925 19.2709 11.9944 20.3489 12.0289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95195 11.4977C5.02999 11.5322 5.9319 10.6863 5.96642 9.60823C6.00095 8.53019 5.15501 7.62828 4.07697 7.59376C2.99892 7.55924 2.09701 8.40517 2.06249 9.48322C2.02797 10.5613 2.87391 11.4632 3.95195 11.4977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78789 6.96644C9.86593 7.00096 10.7678 6.15503 10.8024 5.07698C10.8369 3.99894 9.99094 3.09703 8.9129 3.06251C7.83486 3.02799 6.93295 3.87392 6.89843 4.95197C6.86391 6.03001 7.70984 6.93192 8.78789 6.96644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8143 7.1891C16.8923 7.22362 17.7942 6.37768 17.8287 5.29964C17.8633 4.2216 17.0173 3.31969 15.9393 3.28517C14.8612 3.25064 13.9593 4.09658 13.9248 5.17462C13.8903 6.25266 14.7362 7.15457 15.8143 7.1891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2592 8.37219C11.4249 8.34579 10.6047 8.59109 9.92188 9.07118C9.2391 9.55127 8.73075 10.2402 8.47335 11.0341C8.09318 12.2019 7.26677 13.172 6.17428 13.733C5.38173 14.1235 4.77083 14.8054 4.46934 15.6359C4.16786 16.4664 4.19912 17.3813 4.55659 18.1893C4.91406 18.9973 5.57007 19.6358 6.38743 19.9714C7.2048 20.3069 8.12023 20.3134 8.9423 19.9896C10.8514 19.2774 12.9642 19.345 14.8238 20.178C15.6235 20.5537 16.5374 20.6058 17.3746 20.3232C18.2118 20.0407 18.9073 19.4454 19.3157 18.662C19.7241 17.8785 19.8139 16.9674 19.5661 16.1193C19.3184 15.2712 18.7524 14.5517 17.9864 14.1113C16.9327 13.4814 16.1708 12.4604 15.8669 11.2709C15.6608 10.4621 15.1976 9.74208 14.5469 9.21929C13.8963 8.6965 13.0934 8.39922 12.2592 8.37219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2969_13416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPawIconSelected);
export default __webpack_public_path__ + "static/media/menu-paw-icon-selected.9beb8a0a.svg";
export { ForwardRef as ReactComponent };